import type { SVGProps } from 'react';
const SvgLocalPharmacy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#local_pharmacy_svg__a)">
      <path
        fill="currentColor"
        d="M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5Zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2Z"
      />
    </g>
    <defs>
      <clipPath id="local_pharmacy_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLocalPharmacy;
